import { axios } from '../RequestClient';

// 브랜드 폰트 리스트 조회
export const getBrandFontList = async () => {
  const { data } = await axios.get('/brand/v1/font/design');
  return data;
};
